import type { Placement } from '@floating-ui/react-dom';

import type { TooltipLabel } from '../Tooltip';
import type { BadgeProps } from './Badge';
import { Tooltip } from '../Tooltip';
import Badge from './Badge';

export type BadgeWTipProps = BadgeProps & {
  tooltip?: TooltipLabel;
  tooltipPlacement?: Placement;
};

export default function BadgeWTip({ tooltip, tooltipPlacement, ...props }: BadgeWTipProps) {
  return (
    <Tooltip label={tooltip} placement={tooltipPlacement}>
      <Badge {...props} />
    </Tooltip>
  );
}
